// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1QQQZ","left":"StickyBox_left__3sPHL","right":"StickyBox_right__2ZsvF"};